import ImageCover from './ImageCover';

export default ImageCover;
